/**
 * The default minimum amount of time to wait between fetch retries when
 * throttled, in milliseconds.
 */
export const DEFAULT_MINIMUM_RETRY_DELAY_WHEN_THROTTLED = 6000;
